<template>
  <div class="lease_contract">
    <!-- 合同信息 -->
    <ContractInfo
      ref="contractInfoRef"
      :contractCategory="contractCategory"
      @getChargeMethodsValue="getChargeMethodsValue"
      @getLeaseDateFrom="getLeaseDateFrom"
      @getLeaseDateUntil="getLeaseDateUntil"
      @relatedContract="relatedContract"
      @clearRentAmount="clearRentAmount"
      @getContractCategory="getContractCategory"
    />
    <!-- tabs切换 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="" name="first">
        <span slot="label">
          空间信息
          <i
            class="el-icon-question"
            style="margin-left: 10px; width: 20px; height: 20px; cursor: pointer"
            @click.stop="openInfoHandler"
          ></i>
        </span>
        <!-- 空间信息 -->
        <SpaceInfo
          ref="spaceInfoRef"
          :leaseDateFrom="leaseDateFrom"
          :leaseDateUntil="leaseDateUntil"
          :detailSpaceChargeMethod="detailSpaceChargeMethod"
          :detailSpaceTableData="detailSpaceTableData"
          :contractCategory="contractCategory"
          @updateTotalRentAmount="updateTotalRentAmount"
          @changePayMethod="changePayMethod"
          @deleteSpaceRowsHandler="deleteSpaceRowsHandler"
          @clearWaterCost="clearWaterCost"
        />
        <!-- 免租期信息 -->
        <RentFreeInfo
          style="display: none"
          ref="rentFreeInfoRef"
          :detailRentFreeTableData="detailRentFreeTableData"
          :leaseDateFrom="leaseDateFrom"
          :leaseDateUntil="leaseDateUntil"
          :contractCategory="contractCategory"
          @rentChange="rentChange"
          @deleteRentInfo="deleteRentInfo"
        />
      </el-tab-pane>
      <el-tab-pane label="物业费用信息" name="second">
        <span slot="label">
          物业费用信息
          <i
            class="el-icon-question"
            style="margin-left: 10px; width: 20px; height: 20px; cursor: pointer"
            @click.stop="openInfoHandler"
          ></i>
        </span>
        <!-- 物业费用信息 -->
        <PropertyExpense
          ref="propertyExpenseRef"
          :leaseDateFrom="leaseDateFrom"
          :leaseDateUntil="leaseDateUntil"
          :detailPropertyExpensesTableData="detailPropertyExpensesTableData"
          :spaceTableData="spaceTableData"
          :contractCategory="contractCategory"
        />
      </el-tab-pane>
      <el-tab-pane label="水电费信息" name="third"
        ><!-- 水电费信息 -->
        <WaterCost
          ref="waterCostRef"
          :leaseDateFrom="leaseDateFrom"
          :leaseDateUntil="leaseDateUntil"
          :detailWaterCostTableData="detailWaterCostTableData"
          :waterSpaceIds="waterSpaceIds"
          :deleteSpaceId="deleteSpaceIdList"
          :isClearWater="isClearWaterCost"
          :spaceTableData="spaceTableData"
          :contractCategory="contractCategory"
          :contractInfoData="contractInfoData"
      /></el-tab-pane>
      <el-tab-pane label="押金信息" name="fourth">
        <!-- 押金信息 -->
        <Deposits
          ref="depositsRef"
          :spaceTableData="spaceTableData"
          :detailDepositsTableData="detailDepositsTableData"
          :contractCategory="contractCategory"
          :contractInfoData="contractInfoData"
        />
      </el-tab-pane>
      <el-tab-pane label="合同团队" name="fifth">
        <!-- 合同团队 -->
        <TeamInfo ref="teamInfoRef" :detailTeamTableData="detailTeamTableData" />
      </el-tab-pane>
      <el-tab-pane label="合同附件" name="sixth">
        <!-- 合同附件 -->
        <ContractAttachment
          ref="contractAttachmentRef"
          :detailAttachTableData="detailAttachTableData"
        />
      </el-tab-pane>
      <el-tab-pane
        label="审批信息"
        name="seventh"
        v-if="operateType === 'detail' || operateType === 'audit' || rejectFlag"
      >
        <!-- 审批信息 -->
        <AuditRecord :detailAuditRecords="detailAuditRecords" />
      </el-tab-pane>
    </el-tabs>

    <!-- 变更说明 -->
    <template
      v-if="
        operateType == 'changeInfo' ||
        operateType == 'changeSubject' ||
        (operateType == 'detail' && changeForm.changeDescription) ||
        (operateType == 'audit' && changeForm.changeDescription)
      "
    >
      <el-collapse v-model="activeCollapses" class="collapse-main-content" style="margin-top: 16px">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapse-title-pre">
              <span></span>
              变更说明
            </div>
          </template>
          <el-form :model="changeForm" :rules="rules">
            <el-form-item
              label="变更说明"
              prop="changeDescription"
              label-width="120px"
              style="margin-right: 20px"
            >
              <el-input
                placeholder="请输入2-500个字符"
                v-model="changeForm.changeDescription"
                type="textarea"
                :disabled="operateType == 'detail' || operateType == 'audit'"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
    </template>
    <!-- 审批信息 -->
    <AuditInfo v-show="operateType === 'audit'" ref="auditInfoRef" />
    <div class="btns">
      <el-button
        v-if="
          operateType === 'add' ||
          operateType === 'edit' ||
          operateType === 'renewal' ||
          operateType === 'changeInfo' ||
          operateType === 'changeSubject'
        "
        type="primary"
        @click="handleSave(0)"
        >保存</el-button
      >
      <el-button
        v-if="
          operateType === 'add' ||
          operateType === 'edit' ||
          operateType === 'renewal' ||
          operateType === 'changeInfo' ||
          operateType === 'changeSubject'
        "
        type="primary"
        @click="handleSave(1)"
        class="btn"
        >提交审核</el-button
      >
      <el-button v-if="operateType === 'audit'" type="primary" @click="handleAudit(0)"
        >通过</el-button
      >
      <el-button v-if="operateType === 'audit'" type="primary" @click="handleAudit(1)"
        >驳回</el-button
      >
      <el-button
        v-if="
          operateType === 'add' ||
          operateType === 'edit' ||
          operateType === 'audit' ||
          operateType === 'renewal' ||
          operateType === 'changeInfo' ||
          operateType === 'changeSubject'
        "
        @click="handleCancel"
        class="btn"
        >取消</el-button
      >
      <el-button
        v-if="
          auditStatus == '02' ||
          auditStatus === '05' ||
          auditStatus === '06' ||
          auditStatus === '07'
        "
        @click="handleRecall"
        class="btn"
        type="primary"
        >撤回</el-button
      >
    </div>
    <RelatedDetailDialog
      v-if="dialogVisible"
      :dialogVisible="dialogVisible"
      :contractId="detailRelatedContractId"
      @closeDialog="closeDialog"
    />
    <FirstSettlementDialog ref="firstSettlementDialogRef" />
  </div>
</template>

<script>
  import ContractInfo from './component/contractInfo';
  import SpaceInfo from './component/spaceInfo';
  import RentFreeInfo from './component/rentFreeInfo';
  import PropertyExpense from './component/propertyExpense';
  import WaterCost from './component/waterCost';
  import Deposits from './component/deposits';
  import TeamInfo from './component/teamInfo';
  import ContractAttachment from './component/contractAttachment';
  import AuditInfo from './component/auditInfo';
  import AuditRecord from './component/auditRecord';
  import RelatedDetailDialog from './component/relatedDetailDialog';
  import API from '@/api/property/leaseContract';
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  import moment from 'moment';
  import { mapState } from 'vuex';
  import { mapNumToString } from '@/utils';
  import { rules } from './data';
  import FirstSettlementDialog from './component/FirstSettlementDialog';
  export default {
    name: 'addLeaseContract',
    mixins: [leaseContractMixin],
    components: {
      ContractInfo,
      SpaceInfo,
      RentFreeInfo,
      PropertyExpense,
      WaterCost,
      Deposits,
      TeamInfo,
      ContractAttachment,
      AuditInfo,
      RelatedDetailDialog,
      AuditRecord,
      FirstSettlementDialog,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      operateType() {
        return this.$route.query.type;
      },
      rejectFlag() {
        return this.$route.query.rejectFlag;
      },
      contractId() {
        return this.$route.query.contractId;
      },
      contractNo() {
        return this.$route.query.contractNo;
      },
      nicheId() {
        return this.$route.query.nicheId;
      },
      auditStatus() {
        return this.$route.query.auditStatus;
      },
      rules() {
        return rules();
      },
      contractStatus() {
        return this.$route.query.contractStatus;
      },
    },
    data() {
      return {
        chargeMethods: '', // 合同计费方式
        leaseDateFrom: '', // 租赁起始日期
        leaseDateUntil: '', // 租赁截止日期
        detailSpaceChargeMethod: '',
        detailSpaceTableData: [],
        detailRentFreeTableData: [],
        detailPropertyExpensesTableData: [],
        detailWaterCostTableData: [],
        detailDepositsTableData: [],
        detailTeamTableData: [],
        detailAttachTableData: [],
        detailAuditRecords: [],
        dialogVisible: false,
        detailRelatedContractId: '',
        waterSpaceIds: [],
        deleteSpaceIdList: [], // 删除空间id
        isClearWaterCost: null, // 是否清空全部
        contractCategory: '01', //合同类型
        changeForm: { changeDescription: '' }, //变更说明字段
        activeCollapses: ['1'],
        isRecall: false,
        activeName: 'first',
        spaceTableData: [],
        contractInfoData: {},
      };
    },
    created() {
      if (
        this.operateType === 'edit' ||
        this.operateType === 'detail' ||
        this.operateType === 'audit' ||
        this.operateType === 'renewal' ||
        this.operateType === 'changeInfo' ||
        this.operateType === 'changeSubject'
      ) {
        this.getContractDetail();
      }
      if (
        this.auditStatus === '02' ||
        (this.auditStatus === '05' && this.contractStatus === '02') ||
        (this.auditStatus === '07' && this.contractStatus === '02') ||
        (this.auditStatus === '06' && this.contractStatus == '05') ||
        (this.auditStatus === '07' && this.contractStatus == '05')
      ) {
        this.isRecall = true;
      }
      console.log('isRecall', this.contractStatus, this.isRecall);
    },
    methods: {
      handleClick() {
        // if (this.contractCategory == '01') {
        console.log('切换', this.$refs.spaceInfoRef.getDataTable());
        this.spaceTableData = this.$refs.spaceInfoRef.getDataTable();
        this.contractInfoData = this.$refs.contractInfoRef.contractInfoData;
        // }
      },
      openInfoHandler() {
        this.$refs.firstSettlementDialogRef.openModal();
      },
      //获取合同类型
      getContractCategory(val) {
        console.log('获取合同类型', val);
        this.contractCategory = val;
        // if (val == '01') {
        //   this.activeName = 'first';
        // } else {
        //   this.activeName = 'second';
        // }
      },
      // 撤回
      async handleRecall() {
        console.log('撤回');
        const { data } = await this.$axios.post(`${API.RECALL}/${this.contractId}`);
        if (data.code == '0') {
          this.$message.success('操作成功');
          this.returnPath();
        } else {
          this.$message.error(data.msg);
        }
      },
      async recall() {
        const { data } = await this.$axios.post(`${API.RECALL}/${this.contractId}`);
        if (data.code == '0') {
          this.$message.success('操作成功');
          this.returnPath();
        } else {
          this.$message.error(data.msg);
        }
      },
      // 删除空间行信息的时候
      deleteSpaceRowsHandler(spaceIdList) {
        console.log('1111', spaceIdList, this);
        this.deleteSpaceIdList = spaceIdList;
      },
      clearWaterCost() {
        console.log('清空');
        this.isClearWaterCost = true;
        setTimeout(() => {
          this.isClearWaterCost = null;
        });
      },
      // 获取当前计费状态
      getChargeMethodsValue(value) {
        this.chargeMethods = value;
        this.$refs.spaceInfoRef.currChargeMethods = value;
      },
      // 获取租赁起始日期
      getLeaseDateFrom(value, flag) {
        this.leaseDateFrom = value;
        console.log(value, flag);
        // 非固定价时 计算空间租金
        // if (!flag) {
        //   this.calcRentAmount();
        // }
      },
      // 获取截止日期
      getLeaseDateUntil(value, flag) {
        this.leaseDateUntil = value;
        console.log(this.isFixedPriceFlag, 'this.isFixedPriceFlag', flag);
        // 非固定价时 计算空间租金
        // if (!flag) {
        //   this.calcRentAmount();
        // }
      },
      calcRentAmount() {
        const startDate = this.$refs.contractInfoRef.contractInfoData.leaseDateFrom;
        const endDate = this.$refs.contractInfoRef.contractInfoData.leaseDateUntil;
        console.log(startDate, endDate, '111');
        const mons = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function lastDay(mo, year) {
          if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
            return 30;
          }
          //2月
          else if (mo === 2) {
            if (isLeapYear(year)) {
              return 29;
            } else {
              return 28;
            }
          }
          //大月
          else {
            return 31;
          }
        }
        function isLeapYear(Year) {
          return (Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0;
        }
        function diff(startDate, endDate) {
          endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD');
          const date = new Date(startDate);
          const year = date.getFullYear(); // 取当年的年
          const month = date.getMonth() + 1; // 取当年的月(月份加一)
          const dd = date.getDate(); // 取当年的日期
          const nowDate = new Date(endDate); // 取现在的时间
          const nowYear = nowDate.getFullYear(); // 取现在的年
          const nowMonth = nowDate.getMonth() + 1; // 取现在的月(月份加一)
          const nowDd = nowDate.getDate(); // 取现在的日期
          const restDd = nowDd - dd < 0 ? lastDay(nowMonth - 1, year) - dd + nowDd : nowDd - dd;
          const restMonth = nowMonth - month < 0 ? 12 + nowMonth - month : nowMonth - month;
          const restYear = nowYear - year;
          let resultMonth = restMonth;
          let resultYear = restYear;
          if (nowDd < dd) {
            resultMonth = restMonth - 1 < 0 ? restMonth - 1 + 12 : restMonth - 1;
          }
          if (nowMonth < month || (nowDd < dd && nowMonth === month)) {
            resultYear = restYear - 1;
          }
          return [resultYear, resultMonth, restDd];
        }
        console.log(diff(startDate, endDate), '2345');
        let arr = diff(startDate, endDate);
        let spacesList = this.$refs.spaceInfoRef.$refs.spaceTable.getTableData().fullData || [];

        let rentList = this.$refs.rentFreeInfoRef.$refs.rentFreeTable.getTableData().fullData || [];
        let rentDateArr = [];
        if (startDate && endDate && spacesList.length > 0) {
          spacesList.map((space) => {
            let everyDayCost = 0;
            let everyDayCostTwo = 0;
            if (space.chargeMethods === '01') {
              // everyDayCost = (
              //   (space.chargePrice / mons[new Date(endDate).getMonth()]) *
              //   space.spaceArea
              // ).toFixed(2);
              everyDayCost = (space.chargePrice / mons[new Date(endDate).getMonth()]).toFixed(2);
            } else {
              everyDayCostTwo = (space.chargePrice / mons[new Date(endDate).getMonth()]).toFixed(2);
            }
            if (space.chargeMethod === '01') {
              // space.rentAmount = (
              //   space.chargePrice * space.spaceArea * arr[0] * 12 +
              //   space.chargePrice * space.spaceArea * arr[1] +
              //   everyDayCost * arr[2]
              // ).toFixed(2);
              space.rentAmount = (
                space.chargePrice * arr[0] * 12 +
                space.chargePrice * arr[1] +
                everyDayCost * arr[2]
              ).toFixed(2);
              space.totalAmount = space.rentAmount + '';
            } else {
              space.rentAmount = (
                space.chargePrice * arr[0] * 12 +
                space.chargePrice * arr[1] +
                everyDayCostTwo * arr[2]
              ).toFixed(2);
              space.totalAmount = space.rentAmount + '';
            }
            // 考虑有免租金
            if (rentList.length > 0) {
              rentList.map((rent) => {
                if (space.spaceId === rent.spaceId) {
                  rentDateArr.push({
                    spaceId: rent.spaceId,
                    freeRentStart: rent.freeRentStart,
                    freeRentEnd: rent.freeRentEnd,
                    chargePrice: space.chargePrice,
                    everyDayCost: everyDayCost,
                    everyDayCostTwo: everyDayCostTwo,
                    chargeMethod: space.chargeMethod,
                    spaceArea: space.spaceArea,
                    rentFreeMonth: diff(
                      `${rent.freeRentStart}-01`,
                      `${rent.freeRentEnd}-${mons[new Date(rent.freeRentEnd).getMonth()]}`
                    ),
                  });
                }
              });
            }
          });
          console.log(spacesList, 'spacesList');
          console.log(rentDateArr, 'rentDateArr');
          this.spaceTableData = spacesList;
          // let totalRent = 0;
          // this.spaceTableData.forEach((space) => {
          //   totalRent = totalRent + Number(space.rentAmount);
          // });

          // 计算出免租金的金额
          const tempArr = [];
          if (rentDateArr.length > 0) {
            rentDateArr.forEach((rent) => {
              tempArr.push(rent.spaceId);
            });
          }
          if (Array.from(new Set(tempArr)).length < tempArr.length) {
            return this.$message({
              showClose: true,
              message: '同一空间免租期不可重叠',
              type: 'warning',
            });
          }
          // let rentFreeAmount = 0;
          if (rentDateArr.length > 0) {
            rentDateArr.map((free) => {
              if (free.chargeMethod === '01') {
                // free.rentFreeAmount = (
                //   free.chargePrice * free.spaceArea * free.rentFreeMonth[0] * 12 +
                //   free.chargePrice * free.spaceArea * free.rentFreeMonth[1] +
                //   free.everyDayCost * free.rentFreeMonth[2]
                // ).toFixed(2);
                free.rentFreeAmount = (
                  free.chargePrice * free.rentFreeMonth[0] * 12 +
                  free.chargePrice * free.rentFreeMonth[1] +
                  free.everyDayCost * free.rentFreeMonth[2]
                ).toFixed(2);
              } else {
                free.rentFreeAmount = (
                  free.chargePrice * free.rentFreeMonth[0] +
                  free.chargePrice * free.rentFreeMonth[1] +
                  free.everyDayCostTwo * free.rentFreeMonth[2]
                ).toFixed(2);
              }
            });
          }
          (this.spaceTableData || []).map((space) => {
            if (rentDateArr.length > 0) {
              (rentDateArr || []).map((rent) => {
                if (space.spaceId === rent.spaceId) {
                  space.rentAmount = Number(space.totalAmount) - Number(rent.rentFreeAmount) + '';
                }
              });
            }
          });

          let totalRent = 0;
          this.spaceTableData.forEach((space) => {
            totalRent = totalRent + Number(space.rentAmount);
          });
          // let totalFreeRent = 0;
          // rentDateArr.forEach((item) => {
          //   totalFreeRent = totalFreeRent + Number(item.rentFreeAmount);
          // });
          this.$refs.contractInfoRef.contractInfoData.totalRentAmount = totalRent;
        }
      },
      // 保存 审批
      handleSave(val) {
        if (val === 0) {
          this.sureSave(val);
        } else {
          // 一个表单六个表格
          let formArr = [];
          // if (this.contractCategory == '01') {
          formArr = [
            { outer: 'contractInfoRef', inner: 'contractRef' },
            { outer: 'spaceInfoRef', inner: 'spaceTable' },
            { outer: 'rentFreeInfoRef', inner: 'rentFreeTable' },
            { outer: 'propertyExpenseRef', inner: 'propertyTable' },
            { outer: 'waterCostRef', inner: 'waterCostTable' },
            { outer: 'depositsRef', inner: 'depositsTable' },
            { outer: 'teamInfoRef', inner: 'teamTable' },
          ];
          // }
          // else {
          //   formArr = [
          //     { outer: 'contractInfoRef', inner: 'contractRef' },
          //     { outer: 'propertyExpenseRef', inner: 'propertyTable' },
          //     { outer: 'waterCostRef', inner: 'waterCostTable' },
          //     { outer: 'depositsRef', inner: 'depositsTable' },
          //     { outer: 'teamInfoRef', inner: 'teamTable' },
          //   ];
          // }
          let resultArr = []; //用来接受返回结果的数组
          const _self = this;
          // eslint-disable-next-line no-inner-declarations
          function checkForm(item) {
            //封装验证表单的函数
            // var result = new Promise(function (resolve, reject) {
            //   _self.$refs[item.outer].$refs[item.inner].validate((valid) => {
            //     console.log(valid, '111122');
            //     if (valid) {
            //       resolve();
            //     } else {checkForm
            //       reject();
            //     }
            //   });
            // });
            var result = new Promise(function (resolve, reject) {
              _self.$refs[item.outer].$refs[item.inner].validate((valid) => {
                if (valid) {
                  resolve();
                } else {
                  reject();
                }
              });
            });
            resultArr.push(result);
            console.log(resultArr, 'resultArr');
          }
          formArr.forEach((item) => {
            checkForm(item);
          });
          Promise.all(resultArr)
            .then(function () {
              _self.sureSave(val);
            })
            .catch(function () {
              console.log('error');
            });
        }
      },
      sureSave(val) {
        console.log('进入接口');
        let contractInfoRefData = this.$refs.contractInfoRef.contractInfoData || {};
        const contractBaseInfo = {
          ...contractInfoRefData,
          invoiceType: Number(contractInfoRefData.invoiceType),
        };
        // 租赁合同判断空间信息
        let leaseContractSpacesList = [];
        // 提交的时候数据判断，保存的时候不判断
        let flag = false;
        let message = '';
        // if (this.contractCategory == '01') {
        console.log(this.$refs.contractInfoRef.contractInfoData, 'contractInfoData');
        leaseContractSpacesList =
          this.$refs.spaceInfoRef.$refs.spaceTable.getTableData().fullData || [];
        if (val === 1 && leaseContractSpacesList.length === 0 && this.contractCategory == '01') {
          return this.$message({
            showClose: true,
            message: '请填写空间信息',
            type: 'warning',
          });
        }
        // 判断空间信息中价格设置
        const isValidSpaceDetails = leaseContractSpacesList.every(
          (item) => item.spaceDetails.length > 0
        );
        if (
          !isValidSpaceDetails &&
          contractBaseInfo.chargeMethod != '02' &&
          contractBaseInfo.contractCategory != '02'
        ) {
          this.$message.error('请补充空间中价格信息');
          return;
        }
        // 变更说明必填校验
        if (
          ['changeInfo', 'changeSubject'].includes(this.operateType) &&
          !this.changeForm.changeDescription
        ) {
          return this.$message({
            showClose: true,
            message: '请填写变更说明',
            type: 'warning',
          });
        }
        // 物业合同不判断空间信息
        let spaceIdArr = [];
        let totalRent = 0;
        let leaseContractFreeRentsList = [];
        // if (this.contractCategory == '01') {
        // 提交的时候数据判断，保存的时候不判断（针对租赁合同）
        if (val == 1 && this.contractCategory == '01') {
          for (const item of leaseContractSpacesList) {
            if (item.spaceAssetNoLeafFlag == 1 && !item.spaceUnitNo) {
              flag = true;
              message = '请补充单元（楼栋）信息';
              continue;
            }
            if (item.spaceUnitNoLeafFlag == 1 && !item.spaceFloorNo) {
              flag = true;
              message = '请补充楼层信息';
              continue;
            }
            if (item.spaceFloorNoLeafFlag == 1 && !item.spaceRoomNo) {
              flag = true;
              message = '请补充房号信息';
              continue;
            }
          }
        }
        if (flag) {
          this.$message.error(message);
          return;
        }
        console.log(JSON.stringify(leaseContractSpacesList), '空间信息');
        if (leaseContractSpacesList.length > 0) {
          leaseContractSpacesList = leaseContractSpacesList.map((space) => {
            const item = this.dictListMap['RENT_EXPENSE_TYPE']?.find(
              (v) => v.value == space.expenseTypeCode
            );
            space.expenseTypeName = item ? item.label : null;
            return space;
          });
          leaseContractSpacesList.forEach((space) => {
            spaceIdArr.push(space.spaceId);
            if (this.chargeMethods === '01') {
              totalRent = totalRent + space.rentAmount;
            }
          });
        }
        console.log(spaceIdArr, '1111');
        // if (this.chargeMethods === '01' && Number(totalRent) > 0) {
        //   this.$refs.contractInfoRef.contractInfoData.totalRentAmount = totalRent;
        // }
        if (this.chargeMethods === '01') {
          leaseContractFreeRentsList =
            this.$refs.rentFreeInfoRef.$refs.rentFreeTable.getTableData().fullData || [];
        }
        // }

        let leaseContractPropertyExpensesList =
          this.$refs.propertyExpenseRef.$refs.propertyTable.getTableData().fullData || [];
        leaseContractPropertyExpensesList = leaseContractPropertyExpensesList.map((item) => {
          return {
            ...item,
            chargeUnitPrice: '1',
            chargePrice: '1',
          };
        });
        // 判断物业费信息中价格设置
        const isValidPropertyExpenseDetails = leaseContractPropertyExpensesList.every(
          (item) => item.leaseContractPropertyDetails.length > 0
        );
        if (
          !isValidPropertyExpenseDetails &&
          contractBaseInfo.chargeMethod != '02' &&
          contractBaseInfo.contractCategory != '02'
        ) {
          this.$message.error('请补充物业费用信息中价格信息');
          return;
        }
        const leaseContractHydropowerExpensesList =
          this.$refs.waterCostRef.$refs.waterCostTable.getTableData().fullData || [];
        const leaseContractDepositsList =
          this.$refs.depositsRef.$refs.depositsTable.getTableData().fullData || [];
        const params = {};
        const leaseContractTeamsList =
          this.$refs.teamInfoRef.$refs.teamTable.getTableData().fullData || [];
        const attachmentsList =
          this.$refs.contractAttachmentRef.$refs.fileTableRef.getTableData() || [];
        params.leaseContract = contractBaseInfo;
        params.isSubmit = val === 0 ? false : true;
        // 空间信息
        if (leaseContractSpacesList.length > 0) {
          params.leaseContractSpaces = leaseContractSpacesList;
        }
        // 免租期信息
        if (leaseContractFreeRentsList.length > 0) {
          const freeRentSpaceIdArr = [];
          leaseContractFreeRentsList.forEach((space) => {
            freeRentSpaceIdArr.push(space.spaceId);
          });
          if (!freeRentSpaceIdArr.every((item) => spaceIdArr.includes(item))) {
            return this.$message({
              showClose: true,
              message: '免租期信息中的空间信息与填写空间信息不一致',
              type: 'warning',
            });
          }
          if (this.mapData(leaseContractFreeRentsList)) {
            return this.$message({
              showClose: true,
              message: '同一空间免租期不能重叠',
              type: 'warning',
            });
          }
          params.leaseContractFreeRents = leaseContractFreeRentsList;
        }
        // 物业费用信息
        console.log(JSON.stringify(leaseContractPropertyExpensesList), '物业信息');
        if (leaseContractPropertyExpensesList.length > 0) {
          const propertyExpensesSpaceIdArr = [];
          leaseContractPropertyExpensesList.forEach((space) => {
            propertyExpensesSpaceIdArr.push(space.spaceId);
          });
          console.log(propertyExpensesSpaceIdArr, 'propertyExpensesSpaceIdArr');
          console.log(spaceIdArr, 'spaceIdArr');
          // if (this.contractCategory == '01') {
          //   if (!propertyExpensesSpaceIdArr.every((item) => spaceIdArr.includes(item))) {
          //     return this.$message({
          //       showClose: true,
          //       message: '物业费用中的空间信息与填写空间信息不一致',
          //       type: 'warning',
          //     });
          //   }
          // }

          // if (this.mapPropertyData(leaseContractPropertyExpensesList)) {
          //   return this.$message({
          //     showClose: true,
          //     message: '同一空间同一种费用类型只能维护一次',
          //     type: 'warning',
          //   });
          // }

          params.leaseContractPropertyExpenses = leaseContractPropertyExpensesList;
        }
        // 水电费信息
        if (leaseContractHydropowerExpensesList.length > 0) {
          const hydropowerExpensesSpaceIdArr = [];
          leaseContractHydropowerExpensesList.forEach((space) => {
            hydropowerExpensesSpaceIdArr.push(space.spaceId);
            if (['01', '04'].includes(space.expenseType)) {
              space.energyType = '01';
            } else if (['02', '03'].includes(space.expenseType)) {
              space.energyType = '02';
            }
          });
          // if (!hydropowerExpensesSpaceIdArr.every((item) => spaceIdArr.includes(item))) {
          //   return this.$message({
          //     showClose: true,
          //     message: '水电费信息中的空间信息与填写空间信息不一致',
          //     type: 'warning',
          //   });
          // }
          // if (this.mapPropertyData(leaseContractHydropowerExpensesList)) {
          //   return this.$message({
          //     showClose: true,
          //     message: '同一空间同一种费用类型只能维护一次',
          //     type: 'warning',
          //   });
          // }
          params.leaseContractHydropowerExpenses = leaseContractHydropowerExpensesList;
        }
        // 押金信息
        if (leaseContractDepositsList.length > 0) {
          // if (this.contractCategory == '01') {
          const depositsSpaceIdArr = [];
          leaseContractDepositsList.forEach((space) => {
            depositsSpaceIdArr.push(space.spaceId);
          });
          // if (!depositsSpaceIdArr.every((item) => spaceIdArr.includes(item))) {
          //   return this.$message({
          //     showClose: true,
          //     message: '押金信息中的空间信息与填写空间信息不一致',
          //     type: 'warning',
          //   });
          // }
          // }
          params.leaseContractDeposits = leaseContractDepositsList;
        }
        // 团队信息
        if (leaseContractTeamsList.length > 0) {
          params.leaseContractTeams = leaseContractTeamsList;
        }
        // 合同附件
        if (attachmentsList.length > 0) {
          params.attachments = attachmentsList;
        }
        // 变更说明
        if (this.changeForm.changeDescription) {
          params.leaseContract.changeDescription = this.changeForm.changeDescription;
        }
        // 合同信息中的关联合同号
        if (contractBaseInfo.relateContractId) {
          params.relateContractId = contractBaseInfo.relateContractId;
        }
        // 招商id
        if (this.nicheId) {
          params.nicheId = this.nicheId;
        }
        // delete contractBaseInfo.relateContractId;
        // 编辑保存加id
        if (this.contractId && this.operateType === 'edit') {
          params.leaseContract.id = this.contractId;
          this.$axios.post(API.UPDATE_LEASE_CONTRACT_API, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        } else if (this.operateType === 'add') {
          // 新增
          this.$axios.post(API.SAVE_LEASE_CONTRACT_API, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        } else if (this.operateType === 'renewal') {
          // 续签
          params.oriContractId = this.contractId;
          this.$axios.post(API.RENEW_LEASE_CONTRACT, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        } else if (this.operateType === 'changeSubject') {
          // 变更合同主体
          params.oriContractId = this.contractId;
          this.$axios.post(API.CHANGE_SUBJECT_LEASE_CONTRACT, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        } else {
          // console.log('变更信息');
          // 变更合同信息
          params.oriContractId = this.contractId;
          this.$axios.post(API.CHANGE_Info_LEASE_CONTRACT, params).then((res) => {
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
              this.returnPath();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        }
      },
      mapData(list) {
        let beforeData = list;
        let tempArr = [];
        let afterArr = [];
        for (let i = 0; i < beforeData.length; i++) {
          if (tempArr.indexOf(beforeData[i].spaceId) === -1) {
            afterArr.push({
              spaceId: beforeData[i].spaceId,
              items: [
                {
                  freeRentStart: beforeData[i].freeRentStart,
                  freeRentEnd: beforeData[i].freeRentEnd,
                },
              ],
            });
            tempArr.push(beforeData[i].spaceId);
          } else {
            for (let j = 0; j < afterArr.length; j++) {
              if (afterArr[j].spaceId === beforeData[i].spaceId) {
                afterArr[j].items.push({
                  freeRentStart: beforeData[i].freeRentStart,
                  freeRentEnd: beforeData[i].freeRentEnd,
                });
                break;
              }
            }
          }
        }
        console.log(afterArr, 'afterArr');
        let flag = false;
        for (let i = 0; i < afterArr.length; i++) {
          for (let j = 0; j < afterArr.length; j++) {
            if (afterArr[i].spaceId === afterArr[j].spaceId) {
              let startArr = [];
              let endArr = [];
              if (afterArr[j].items.length > 0) {
                afterArr[j].items.map((item) => {
                  startArr.push(item.freeRentStart), endArr.push(item.freeRentEnd);
                });
              }
              if (
                Array.from(new Set(startArr)).length < startArr.length ||
                Array.from(new Set(endArr)).length < endArr.length
              ) {
                flag = true;
              }
            }
          }
        }
        // const startArr = [];
        // const endArr = [];
        // afterArr.map((arr) => {
        //   if (arr.items.length > 1) {
        //     arr.items.map((item) => {
        //       startArr.push(item.freeRentStart), endArr.push(item.freeRentEnd);
        //     });
        //   }
        // });
        // console.log(startArr, 'startArr');
        // console.log(endArr, 'endArr');
        // if (
        //   Array.from(new Set(startArr)).length < startArr.length &&
        //   Array.from(new Set(endArr)).length < endArr.length
        // ) {
        //   flag = true;
        // }
        return flag;
      },
      mapPropertyData(list) {
        let beforeData = list;
        let tempArr = [];
        let afterArr = [];
        for (let i = 0; i < beforeData.length; i++) {
          if (tempArr.indexOf(beforeData[i].spaceId) === -1) {
            afterArr.push({
              spaceId: beforeData[i].spaceId,
              items: [beforeData[i].expenseType],
            });
            tempArr.push(beforeData[i].spaceId);
          } else {
            for (let j = 0; j < afterArr.length; j++) {
              if (afterArr[j].spaceId === beforeData[i].spaceId) {
                afterArr[j].items.push(beforeData[i].expenseType);
                break;
              }
            }
          }
        }
        console.log(afterArr, '11111111');
        let flag = false;
        afterArr.map((arr) => {
          if (arr.items.length > 0) {
            if (Array.from(new Set(arr.items)).length < arr.items.length) {
              flag = true;
            }
          }
        });
        return flag;
      },
      // 取消
      handleCancel() {
        this.returnPath();
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/property/leaseContract',
            name: 'leaseContractManage',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      // 获取数据
      getContractDetail() {
        console.log(this.contractId, '1111');
        console.log('--------------------------获取');
        // if (!this.contractId || !this.contractNo) return;
        this.$axios
          .get(
            this.contractId
              ? `${API.DETAIL_LEASE_CONTRACT_API}/${this.contractId}`
              : `${API.DETAIL_LEASE_CONTRACT_NO_API}/${this.contractNo}`
          )
          .then((res) => {
            console.log(res, '123456');
            if (res.data.code === 0) {
              const contractDetailData = res.data.data || {};
              this.chargeMethods = contractDetailData.leaseContract.chargeMethod;
              this.detailRelatedContractId = contractDetailData.leaseContract.id;
              this.contractCategory = contractDetailData.leaseContract.contractCategory;
              // if (this.contractCategory == '01') {
              //   this.activeName = 'first';
              // } else {
              //   this.activeName = 'second';
              // }
              this.changeForm.changeDescription =
                contractDetailData.leaseContract.changeDescription;
              this.getContractInfoDetail(contractDetailData);
              this.getSpaceInfoDetail(contractDetailData);
              this.getRentFreeInfoDetail(contractDetailData);
              this.getPropertyExpenseDetail(contractDetailData);
              this.getWaterCostDetail(contractDetailData);
              this.getDepositsDetail(contractDetailData);
              this.getTeamDetail(contractDetailData);
              this.getAttachDetail(contractDetailData);
              if (
                this.operateType === 'detail' ||
                this.operateType === 'audit' ||
                this.rejectFlag
              ) {
                this.getAuditRecordDetail(contractDetailData);
              }
            }
          });
      },
      getContractInfoDetail(detailData) {
        const leaseContract = detailData.leaseContract;
        // 续签时 租赁开始日期变换 合同总租金变为0
        let newLeaseDateFrom = '';
        let newLeaseDateUntil = '';
        let newSignDate = '';
        let totalRentAmount = 0;
        if (this.operateType === 'renewal') {
          newLeaseDateFrom = moment(leaseContract.leaseDateUntil)
            .add(1, 'days')
            .format('YYYY-MM-DD');
          newLeaseDateUntil = '';
          newSignDate = moment().format('YYYY-MM-DD');
          totalRentAmount = 0;
        } else {
          newLeaseDateFrom = leaseContract.leaseDateFrom;
          newLeaseDateUntil = leaseContract.leaseDateUntil;
          newSignDate = leaseContract.signDate;
          totalRentAmount = leaseContract.totalRentAmount;
        }
        const baseDataDetailInfo = {
          contractCompanyName: leaseContract.contractCompanyName,
          contractCompanyNo: leaseContract.contractCompanyNo,
          contractName: leaseContract.contractName,
          contractNo: leaseContract.contractNo,
          contractDepartmentNo: leaseContract.contractDepartmentNo,
          contractDepartmentName: leaseContract.contractDepartmentName,
          customerCode: leaseContract.customerCode,
          customerName: leaseContract.customerName,
          creditCode: leaseContract.creditCode,
          contractCategory: leaseContract.contractCategory,
          leaseDateFrom: newLeaseDateFrom,
          leaseDateUntil: newLeaseDateUntil,
          chargeMethod: leaseContract.chargeMethod,
          totalRentAmount: totalRentAmount
            ? parseFloat(totalRentAmount).toFixed(2)
            : totalRentAmount,
          rentAmount: leaseContract.rentAmount,
          chargeCycle: leaseContract.chargeCycle,
          firstSettlementDate: leaseContract.firstSettlementDate,
          rentAnnualGrowthRate: leaseContract.rentAnnualGrowthRate,
          collectionOverdueDay: leaseContract.collectionOverdueDay,
          defaultPenaltyRate: leaseContract.defaultPenaltyRate,
          signPartyName: leaseContract.signPartyName,
          signDate: newSignDate,
          signPersonName: leaseContract.signPersonName,
          signPlace: leaseContract.signPlace,
          relateContractId: leaseContract.relateContractId,
          paperContractNo: leaseContract.paperContractNo,
          partyaBankAccount: leaseContract.partyaBankAccount,
          partyaDepositBank: leaseContract.partyaDepositBank,
          partyaContactPerson: leaseContract.partyaContactPerson,
          partyaContactPhone: leaseContract.partyaContactPhone,
          partybInvoiceInfo: leaseContract.partybInvoiceInfo,
          partybContactPerson: leaseContract.partybContactPerson,
          partybContactPhone: leaseContract.partybContactPhone,
          remark: leaseContract.remark,
          contractStatus: leaseContract.contractStatus,
          invoiceType: leaseContract.invoiceType,
        };
        // 1.反填表单数据
        Object.assign(
          this.$refs.contractInfoRef.contractInfoData,
          mapNumToString(baseDataDetailInfo)
        );
        // 有签约方展示 签约方
        this.$refs.contractInfoRef.showSignPartyNameFlag = leaseContract.signPartyName
          ? true
          : false;
        this.$refs.contractInfoRef.isFixedPriceFlag =
          leaseContract.chargeMethod === '02' ? true : false;
        this.$refs.contractInfoRef.dateFrom = newLeaseDateFrom;
        this.$refs.contractInfoRef.dateUntil = newLeaseDateUntil;
        this.leaseDateUntil = newLeaseDateUntil;
        this.leaseDateFrom = newLeaseDateFrom;
        this.isFixedPriceFlag = leaseContract.chargeMethod === '02' ? true : false;
      },
      getSpaceInfoDetail(detailData) {
        const leaseContractSpaces = detailData.leaseContractSpaces || [];
        let waterSpaceIds = [];
        const mons = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function lastDay(mo, year) {
          if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
            return 30;
          }
          //2月
          else if (mo === 2) {
            if (isLeapYear(year)) {
              return 29;
            } else {
              return 28;
            }
          }
          //大月
          else {
            return 31;
          }
        }
        function isLeapYear(Year) {
          return (Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0;
        }
        function diff(startDate, endDate) {
          endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD');
          const date = new Date(startDate);
          const year = date.getFullYear(); // 取当年的年
          const month = date.getMonth() + 1; // 取当年的月(月份加一)
          const dd = date.getDate(); // 取当年的日期
          const nowDate = new Date(endDate); // 取现在的时间
          const nowYear = nowDate.getFullYear(); // 取现在的年
          const nowMonth = nowDate.getMonth() + 1; // 取现在的月(月份加一)
          const nowDd = nowDate.getDate(); // 取现在的日期
          const restDd = nowDd - dd < 0 ? lastDay(nowMonth - 1, year) - dd + nowDd : nowDd - dd;
          const restMonth = nowMonth - month < 0 ? 12 + nowMonth - month : nowMonth - month;
          const restYear = nowYear - year;
          let resultMonth = restMonth;
          let resultYear = restYear;
          if (nowDd < dd) {
            resultMonth = restMonth - 1 < 0 ? restMonth - 1 + 12 : restMonth - 1;
          }
          if (nowMonth < month || (nowDd < dd && nowMonth === month)) {
            resultYear = restYear - 1;
          }
          return [resultYear, resultMonth, restDd];
        }
        if (leaseContractSpaces.length > 0) {
          this.detailSpaceChargeMethod = detailData.leaseContract.chargeMethod;
          leaseContractSpaces.map((item) => {
            waterSpaceIds.push(item.spaceId + '');
            item.spaceId = item.spaceId + '';
            // 续期时 空间信息租金变为0
            if (this.operateType === 'renewal') {
              item.rentAmount = 0;
            }
            // 租金固定供免租减免
            // item.totalAmount = item.rentAmount;
            item.arr = diff(
              detailData.leaseContract.leaseDateFrom,
              detailData.leaseContract.leaseDateUntil
            );
            // item.everyDayCost = (
            //   (item.chargePrice /
            //     mons[new Date(detailData.leaseContract.leaseDateUntil).getMonth()]) *
            //   item.spaceArea
            // ).toFixed(2);
            item.everyDayCost = (
              item.chargePrice / mons[new Date(detailData.leaseContract.leaseDateUntil).getMonth()]
            ).toFixed(2);
            item.everyDayCostTwo = (
              item.chargePrice / mons[new Date(detailData.leaseContract.leaseDateUntil).getMonth()]
            ).toFixed(2);
            if (item.chargeMethod === '01') {
              // 平米
              // item.totalAmount =
              //   item.chargePrice * item.spaceArea * item.arr[0] * 12 +
              //   item.chargePrice * item.spaceArea * item.arr[1] +
              //   item.everyDayCost * item.arr[2];
              item.totalAmount =
                item.chargePrice * item.arr[0] * 12 +
                item.chargePrice * item.arr[1] +
                item.everyDayCost * item.arr[2];
            } else {
              // 固定价
              item.totalAmount =
                item.chargePrice * item.arr[0] * 12 +
                item.chargePrice * item.arr[1] +
                item.everyDayCostTwo * item.arr[2];
            }
          });
          // 2.空间信息
          this.detailSpaceTableData = leaseContractSpaces;
          this.waterSpaceIds = waterSpaceIds;
        }
      },
      getRentFreeInfoDetail(detailData) {
        const leaseContractFreeRents = detailData.leaseContractFreeRents || [];
        if (leaseContractFreeRents.length > 0) {
          leaseContractFreeRents.map((item) => {
            item.spaceId = item.spaceId + '';
          });
          this.detailRentFreeTableData = leaseContractFreeRents;
        }
      },
      getPropertyExpenseDetail(detailData) {
        const leaseContractPropertyExpenses = detailData.leaseContractPropertyExpenses || [];
        if (leaseContractPropertyExpenses.length > 0) {
          leaseContractPropertyExpenses.map((item) => {
            item.spaceId = item.spaceId + '';
          });
          this.detailPropertyExpensesTableData = leaseContractPropertyExpenses;
        }
      },
      getWaterCostDetail(detailData) {
        const leaseContractHydropowerExpenses = detailData.leaseContractHydropowerExpenses || [];
        if (leaseContractHydropowerExpenses.length > 0) {
          leaseContractHydropowerExpenses.map((item) => {
            item.spaceId = item.spaceId + '';
          });
          // 给水电表赋值
          this.detailWaterCostTableData = leaseContractHydropowerExpenses;
        }
      },
      getDepositsDetail(detailData) {
        const leaseContractDeposits = detailData.leaseContractDeposits || [];
        if (leaseContractDeposits.length > 0) {
          leaseContractDeposits.map((item) => {
            item.spaceId = item.spaceId + '';
          });
          this.detailDepositsTableData = leaseContractDeposits;
        }
      },
      getTeamDetail(detailData) {
        const leaseContractTeams = detailData.leaseContractTeams || [];
        if (leaseContractTeams.length > 0) {
          this.detailTeamTableData = leaseContractTeams;
        }
      },
      getAttachDetail(detailData) {
        const attachments = detailData.attachments || [];
        if (attachments.length > 0) {
          this.detailAttachTableData = attachments;
        }
      },
      getAuditRecordDetail(detailData) {
        let auditRecords = detailData.records || [];
        console.log(auditRecords, 'auditRecords');
        if (auditRecords.length > 0) {
          this.detailAuditRecords = auditRecords;
        }
      },
      // 审核
      handleAudit(val) {
        this.$refs.auditInfoRef.$refs.auditRef.validate((valid) => {
          if (valid) {
            const paperContractNo = this.$refs.contractInfoRef.contractInfoData?.paperContractNo;
            const params = {
              info: this.$refs.auditInfoRef.auditInfoData.info || '',
              paperContract: paperContractNo,
            };
            this.$axios
              .post(
                val === 0
                  ? `${API.AUDIT_LEASE_CONTRACT_API}/${this.contractId}/pass?info=${params.info}&paperContract=${paperContractNo}`
                  : `${API.AUDIT_LEASE_CONTRACT_API}/${this.contractId}/reject?info=${params.info}&paperContract=${paperContractNo}`,
                params
              )
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.returnPath();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
          }
        });
      },
      relatedContract() {
        this.dialogVisible = true;
      },
      closeDialog() {
        this.dialogVisible = false;
      },
      rentChange(row) {
        console.log(row, '1111');

        // let currSpaceId = row.spaceId;
        // this.$refs.spaceInfoRef.updateChangeRentAmount(
        //   currSpaceId,
        //   row.freeRentStart,
        //   row.freeRentEnd
        // );
      },
      deleteRentInfo(list) {
        console.log('234567');

        const spaceList = this.$refs.spaceInfoRef.$refs.spaceTable.getTableData().fullData || [];
        console.log(list, 'list');
        console.log(spaceList, 'spaceList');
        const mons = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        console.log(mons);
        function lastDay(mo, year) {
          if (mo === 4 || mo === 6 || mo === 9 || mo === 11) {
            return 30;
          }
          //2月
          else if (mo === 2) {
            if (isLeapYear(year)) {
              return 29;
            } else {
              return 28;
            }
          }
          //大月
          else {
            return 31;
          }
        }
        function isLeapYear(Year) {
          return (Year % 4 === 0 && Year % 100 !== 0) || Year % 400 === 0;
        }
        function diff(startDate, endDate) {
          endDate = moment(endDate).add(1, 'days').format('YYYY-MM-DD');
          const date = new Date(startDate);
          const year = date.getFullYear(); // 取当年的年
          const month = date.getMonth() + 1; // 取当年的月(月份加一)
          const dd = date.getDate(); // 取当年的日期
          const nowDate = new Date(endDate); // 取现在的时间
          const nowYear = nowDate.getFullYear(); // 取现在的年
          const nowMonth = nowDate.getMonth() + 1; // 取现在的月(月份加一)
          const nowDd = nowDate.getDate(); // 取现在的日期
          const restDd = nowDd - dd < 0 ? lastDay(nowMonth - 1, year) - dd + nowDd : nowDd - dd;
          const restMonth = nowMonth - month < 0 ? 12 + nowMonth - month : nowMonth - month;
          const restYear = nowYear - year;
          let resultMonth = restMonth;
          let resultYear = restYear;
          if (nowDd < dd) {
            resultMonth = restMonth - 1 < 0 ? restMonth - 1 + 12 : restMonth - 1;
          }
          if (nowMonth < month || (nowDd < dd && nowMonth === month)) {
            resultYear = restYear - 1;
          }
          return [resultYear, resultMonth, restDd];
        }
        list.map((item) => {
          if (spaceList.length > 0) {
            spaceList.map((space) => {
              if (item.spaceId === space.spaceId) {
                let arr = [];
                arr = diff(item.freeRentStart, item.freeRentEnd);
                console.log(arr, 'arr');
                // space.rentAmount =
                //   Number(space.rentAmount) +
                //   Number(arr[0] * 12 * space.chargePrice) +
                //   Number(arr[1] * space.chargePrice) +
                //   Number(
                //     arr[2] *
                //       (space.chargePrice / mons[new Date(item.freeRentEnd).getMonth()]).toFixed(2)
                //   );
                // space.rentAmount =
                //   (
                //     space.rentAmount +
                //     arr[0] * 12 * space.chargePrice +
                //     arr[1] * space.chargePrice +
                //     arr[2] *
                //       (space.chargePrice / mons[new Date(item.freeRentEnd).getMonth()]).toFixed(2)
                //   ).toFixed(2) || 0;
                // space.totalAmount = space.rentAmount;
              }
            });
          }
        });
        this.$refs.spaceInfoRef.spaceTableData = spaceList;
        let totalRent = 0;
        spaceList.forEach((space) => {
          totalRent = totalRent + Number(space.rentAmount);
        });
        this.updateTotalRentAmount(totalRent);
      },
      updateTotalRentAmount(val) {
        console.log(val);
        // this.$refs.contractInfoRef.contractInfoData.totalRentAmount = val;
      },
      clearRentAmount() {
        console.log('111');
        const list = this.$refs.spaceInfoRef.$refs.spaceTable.getTableData().fullData || [];
        list.map((item) => {
          item.chargePrice = '';
          item.chargeUnitPrice = '';
          item.rentAmount = '';
        });
        this.$refs.spaceInfoRef.spaceTableData = list;
        this.$refs.rentFreeInfoRef.rentFreeTableDate = [];
      },
      // 非固定价时 空间信息中某个空间改变计费方式 删除免租期信息中该空间的免租信息 并计算免租金额 增加到合同信息中的合同总租金中
      changePayMethod(row) {
        console.log(row, '-----------------');
        console.log(this.chargeMethods, 'this.chargeMethods');
        // 合同信息中计费方式为非固定价
        if (this.chargeMethods === '01') {
          const spaceId = row.spaceId;
          const rentAmount = row.totalAmount;
          console.log(rentAmount, 'rentAmount');
          let rentFreeList =
            this.$refs.rentFreeInfoRef.$refs.rentFreeTable.getTableData().fullData || [];
          if (rentFreeList.length > 0) {
            let newRentFreeList = rentFreeList.filter((item) => item.spaceId !== spaceId);
            this.$refs.rentFreeInfoRef.rentFreeTableDate = newRentFreeList;
          }
          if (rentAmount) {
            this.$refs.contractInfoRef.getAllAmout(rentAmount);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btns {
    margin-top: 16px;
    display: flex;
    .btn {
      margin-left: 12px;
    }
  }
  ::v-deep {
    .el-tabs--card > .el-tabs__header {
      border-bottom: none;
    }
    .el-tabs__nav {
      background: #fff !important;
    }
    .el-collapse {
      border-top: none;
      border-bottom: none;
    }
  }
</style>
